import { decryptInteger } from "@/Utils/encryptInteger";
import { useRouter } from "next/router";
import { createContext, useContext, useEffect, useState } from "react";
import toast from "react-hot-toast";

const DashboardContext = createContext(null);

export function DashboardProvider({ children }) {
    const router = useRouter();
    const [tickets, setTickets] = useState();
    const [dsQuery, setDsQuery] = useState("");
    const [loggedUserDetails, setLoggedUserDetails] = useState(null)
    const [currentPage, setCurrentPage] = useState(0)
    const [isUpdateProfileInfo, setIsUpdateProfileInfo] = useState(false)

    useEffect(() => {
        const encryptedData = localStorage.getItem("user_data");

        if (encryptedData) {
            try {
                const decryptedString = decryptInteger(encryptedData);
                const userData = JSON.parse(decryptedString);

                setLoggedUserDetails({
                    status: true,
                    data: userData,
                });
            } catch (error) {
                console.error("Decryption failed:", error);
                localStorage.removeItem("user_data");
                setLoggedUserDetails(null);
                router.push("/")
            }
        } else {
            setLoggedUserDetails(null);
            router.push("/")
        }
    }, []);

    useEffect(() => {
        async function fetchTickets() {
            try {

                const encryptedData = localStorage.getItem("user_data");
                let data = JSON.parse(decryptInteger(encryptedData));
                let web_token = data?.web_token 

                if(!data) {
                    router.push("/")
                    return ;
                }

                const formData = new URLSearchParams();
                formData.append("action", "fetchMyTickets");
                formData.append("page_index", currentPage);

                const response = await fetch(`${process.env.NEXT_PUBLIC_BACKEND_URL}/webapi/manageTicket`, {
                    method: "POST",
                    headers: { Authorization: `Bearer ${web_token}` },
                    body: formData,
                });

                let resData = await response.json();

                if(!resData.status) {
                    localStorage.clear();
                    sessionStorage.clear();
                    router.push("/");
                    return
                }

                if (currentPage == 0) {
                    setTickets(resData.data)
                } else {
                    setTickets([...tickets, ...resData.data])
                }

            } catch (error) {
                console.log("error", error)
            }
        }
        fetchTickets();
    }, [currentPage, loggedUserDetails, router.pathname])


    return (
        <DashboardContext.Provider value={{
            tickets, setTickets,
            dsQuery, setDsQuery,
            loggedUserDetails, setLoggedUserDetails,
            currentPage, setCurrentPage,
            tickets, setTickets,
            isUpdateProfileInfo, setIsUpdateProfileInfo,
        }}>
            {children}
        </DashboardContext.Provider>
    );
}

export function useDashboard() {
    const context = useContext(DashboardContext);
    if (!context) {
        throw new Error("useDashboard must be used within a DashboardProvider");
    }
    return context;
}